/**
 * 全菜单列表，根据auth字段控制菜但权限
 * auth为空：该菜单可以被所有用户访问
 * 父级菜单的权限范围 >= 子菜单的权限范围
 * 目前权限分为五类：
 * default: 默认权限
 * keyword: 可以配置关键字
 * file_out：可以配置文件外发
 * cryptbox：可以二拍子会密盒策略
 * root：系统管理员，可以操作所有菜单
 */
export default [
  {
    name: '下载记录',
    i18n: 'wenshu_menu_download_record',
    path: 'file_mine',
    icon: 'icon-mtdicons-file-o',
  },
  {
    name: '我的设备',
    i18n: 'wenshu_menu_my_device',
    path: 'client_mine',
    icon: 'icon-mtdicons-monitor',
  },
  {
    name: '外发报备',
    i18n: 'wenshu_menu_outgoing_apply',
    path: 'file_outer_upload',
    icon: 'icon-cs-icon-wodegongdan',
  },
  {
    name: '外发记录',
    i18n: 'wenshu_menu_outgoing_record',
    path: 'file_outer',
    icon: 'icon-cs-icon-jieangongdan',
    children: [
      {
        name: '我的外发记录',
        i18n: 'wenshu_menu_my_outgoing_record',
        path: 'file_outer/file_out_list',
      },
      {
        name: '下属外发记录',
        i18n: 'wenshu_menu_sub_outgoing_record',
        path: 'file_outer/subordinate_out_list',
      }
    ]
  },
  {
    name: '流转记录',
    i18n: 'wenshu_menu_track_record',
    path: 'file_trace',
    icon: 'icon-mtbi-zhuandaomingxikuanbiao',
    children: [
      {
        name: '流转报告',
        i18n: 'wenshu_menu_track_report',
        path: 'file_trace/alert_list',
      },
      {
        name: '流转详情',
        i18n: 'wenshu_menu_track_detail',
        path: 'file_trace/alert_detail',
      }
    ]
  },
  {
    name: '合规审计',
    i18n: 'wenshu_menu_audit',
    path: 'compliance_audit',
    icon: 'icon-mtdicons-folder',
    auth: ['file_trace_audit', 'file_outgoing'],
    children: [
      {
        name: '文枢外发审计',
        i18n: 'wenshu_menu_outgoing_audit',
        auth: ['file_outgoing'],
        path: 'compliance_audit/other_out',
        children: [
          {
            name: '外发记录查询',
            i18n: 'wenshu_menu_outgoing_record_search',
            path: 'compliance_audit/other_out/file_out_list',
          },
          {
            name: '外发审计申请',
            i18n: 'wenshu_menu_outgoing_audit_apply',
            path: 'compliance_audit/other_out/view_apply',
          }
        ]
      },
      {
        name: '流转审计',
        i18n: 'wenshu_menu_track_audit',
        path: 'compliance_audit/other_trace',
        auth: ['file_trace_audit'],
        children: [
          {
            name: '流转记录查询',
            i18n: 'wenshu_menu_track_record_search',
            path: 'compliance_audit/other_trace/alert_list',
          },
          {
            name: '流转详情查询',
            i18n: 'wenshu_menu_track_detail_search',
            path: 'compliance_audit/other_trace/alert_detail',
          },
          {
            name: '流转审计申请',
            i18n: 'wenshu_menu_track_audit_apply',
            path: 'compliance_audit/other_trace/view_apply',
          }
        ]
      },
    ]
  },
  {
    name: '文枢空间挂载申请',
    i18n: 'wenshu_menu_disk_mount_apply',
    path: 'wenshu_device/mount_apply',
    icon: 'icon-mtdicons-lookup',
  },
  {
    name: '文件上传',
    i18n: 'wenshu_menu_file_upload',
    path: 'wenshu_file_collect',
    icon: 'icon-mtdicons-newfolde',
  },
]
